
import {useSelector} from "react-redux";

// import $ from 'jquery';
// window.jQuery = $;
// require('signalr');

const AttendancesResume = (props) => {
	const {DataCompany} = useSelector(state => state.auth);
	if (!DataCompany?.Token) {
		return <></>;
	}

	return (
		<iframe 
			title="unique"
			src={`${process.env.REACT_APP_IFRAME_V2_URL}/asistencia?token=${DataCompany.Token}&moduleId=${process.env.REACT_APP_MODULE_ID}`}
        	style={{
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				maxHeight: '100%',
				position: "border: none"
			}}        
        />
	);
};

export default AttendancesResume;
